import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=c23050fa"
import script from "./statistics.vue?vue&type=script&lang=ts"
export * from "./statistics.vue?vue&type=script&lang=ts"
import style0 from "./statistics.vue?vue&type=style&index=0&id=c23050fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports